import styles from './SideBar.module.scss'

interface SideBarChevronProps {
  /**
   * When true the chevron uses the bright-orange "open" look and points up
   * (rotated 180°); otherwise it points down in the white "closed" look. Hover
   * behaviour is driven by the `menuButtonActive` / `menuButtonInactive` class
   * on the surrounding wrapper.
   */
  highlighted: boolean
  /** Toggles the section. Same handler the row itself carries. */
  onClick: () => void
  /** Names the section, since the control itself has no text. */
  label: string
}

/**
 * A real button, not decoration.
 *
 * It looks like something to press and sits in the empty strip to the right of
 * the row's own button, which is `width: fit-content` and therefore does not
 * reach it. Left as an `<i>` with `pointer-events: none` that strip swallowed
 * the click and the section neither opened nor closed.
 */
function SideBarChevron({ highlighted, onClick, label }: SideBarChevronProps) {
  return (
    <button
      type="button"
      className={`las la-angle-down ${styles.menuChevron} ${
        highlighted ? styles.menuChevronOpen : styles.menuChevronClosed
      }`}
      onClick={onClick}
      aria-label={label}
      aria-expanded={highlighted}
    />
  )
}

export default SideBarChevron
